import {
  reportSubmenu,
  reportSubmenuTT09
} from 'src/app/components/tables/constance';

const reportSubmenuDN = [
  {
    label: 'Báo cáo tổng hợp hoạt động',
    route: '/baocao-dn/bao-cao-ve-tong-hop-hoat-dong-theo-nhom'
  },
  {
    label: 'Báo cáo chi tiết hoạt động',
    route: '/baocao-dn/bao-cao-chi-tiet-hoat-dong'
  },
  {
    label: 'Báo cáo tổng hợp nhiên liệu',
    route: '/baocao-dn/bao-cao-tong-hop-nhien-lieu'
  },
  {
    label: 'Báo cáo tiêu hao nhiên liệu',
    route: '/baocao-dn/bao-cao-tieu-hao-nhien-lieu'
  },
  {
    label: 'Báo cáo biến động nhiên liệu',
    route: '/baocao-dn/bao-cao-do-hut-nhien-lieu'
  },
  {
    label: 'Báo cáo vào ra vùng giám sát',
    route: '/baocao-dn/bao-cao-vao-ra-vung-giam-sat'
  },
  {
    label: 'Báo cáo tuyến lộ trình',
    route: '/baocao-dn/bao-cao-chuyen-kinh-doanh'
  },
  {
    label: 'Báo cáo đóng mở cửa',
    route: '/baocao-dn/bao-cao-dong-mo-cua'
  },
  {
    label: 'Báo cáo bật điều hòa',
    route: '/baocao-dn/bao-cao-bat-dieu-hoa'
  },
  {
    label: 'Báo cáo động cơ',
    route: '/baocao-dn/bao-cao-dong-co'
  },
];

export const itemsReport = [
  {
    label: 'Báo cáo QCVN 06:2024/BCA',
    route: '/baocao-bgt/tt073/',
    children: reportSubmenu.map(item => ({
      label: item.name,
      route: item.url
    }))
  },
  // {
  //   label: 'Báo cáo TT71/2024/TT-BCA',
  //   route: '/baocao-bgt/tt09/',
  //   children: reportSubmenuTT09.map(item => ({
  //     label: item.name,
  //     route: item.url
  //   }))
  // },
  {
    label: 'Báo cáo doanh nghiệp',
    route: '/baocao-dn',
    children: reportSubmenuDN
  }
];
